"use client"

import { ApiReferenceReact } from "@scalar/api-reference-react"
import "@scalar/api-reference-react/style.css"

/**
 * Scalar-rendered OpenAPI reference with theming aligned to the
 * Aperture-Light palette. Scalar fetches /openapi.yaml at runtime,
 * so updating the spec is a one-file change.
 *
 * Why Scalar over Swagger UI / Redoc:
 *   - Modern look out of the box (matches our editorial vibe better)
 *   - Built-in "try it" panel that hits the live endpoint with the
 *     user's own bearer token
 *   - Lightweight bundle (single React component)
 */
export default function ApiReference() {
  return (
    <div
      className="min-h-screen w-full"
      style={{
        // Scalar respects CSS custom properties — pin them to the
        // Aperture-Light tokens so the docs read as part of the same
        // design system as the rest of /docs.
        // @ts-expect-error — CSS vars on style prop
        "--scalar-color-1": "#0A0A0A",
        "--scalar-color-2": "rgba(10,10,10,0.62)",
        "--scalar-color-3": "rgba(10,10,10,0.42)",
        "--scalar-color-accent": "#0F5132",
        "--scalar-background-1": "#FAF7EE",
        "--scalar-background-2": "#FBF8F0",
        "--scalar-background-3": "#FFFFFF",
        "--scalar-background-accent": "#DFF5E5",
        "--scalar-border-color": "rgba(10,10,10,0.10)",
        "--scalar-radius": "10px",
        "--scalar-radius-lg": "14px",
        "--scalar-font": '"Geist", system-ui, sans-serif',
        "--scalar-font-code": '"JetBrains Mono", ui-monospace, monospace',
      }}
    >
      <ApiReferenceReact
        configuration={{
          url: "/openapi.yaml",
          theme: "default",
          layout: "modern",
          hideClientButton: false,
          metaData: {
            title: "DataBridge API",
            description:
              "Clean email lists programmatically — same core checks that power the dashboard.",
          },
          authentication: {
            preferredSecurityScheme: "bearerAuth",
          },
          // Default the "try it" sandbox to a simple example so
          // first-time visitors can hit the endpoint without typing
          // a CSV from scratch.
          customCss: `
            .references-rendered {
              font-family: var(--scalar-font);
            }
          `,
        }}
      />
    </div>
  )
}
